import { Box, CircularProgress } from "@mui/material"

export default ({ sx = {}, ...props }) => (
  <Box
    sx={{
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      ...sx,
    }}
    {...props}
  >
    <CircularProgress size={70} className="loader" />
  </Box>
)
